import React, { Component } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import LatestVisaFollowUp from "../../../components/_utils/latestVisaFollowup";
import TableComp from "../../../components/_utils/table";
import VisaListFollowUps from "../../../components/_utils/visaListFollowUp";
import moment from "moment";
import { RightsWrapper } from "../../../components/_utils/utils";
import {
  Button,
  Card,
  notification,
  Popconfirm,
  Tooltip,
  DatePicker,
  Row,
  Col,
  Select,
  Tabs,
  Form,
  Drawer,
} from "antd";
import Request, { API_URL, LAPI_URL } from "../../../request";
import styles from "./style.less";
import { connect } from "react-redux";
import common from "../../common.less";
import _ from "lodash";
import { hideLoader, showLoader } from "../../../modules/actions";
import ClickToCallDrawer from '../../Student/inquiry/all/clickToCall';
import rightAuth from "../../../components/_utils/userRights";
import { FormUtils as GetAllFormFields } from 'sz-react-utils';
import PDFFileView from "../../../components/DocumentViews/PDFFileView";
let dateFormat = localStorage.getItem("company-details")
  ? JSON.parse(localStorage.getItem("company-details")).dateFormat
  : "DD.MM.YYYY";
let localUser = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;
const todayDate = moment().format("YYYYMMDD");
let studentObj = {};
const { RangePicker } = DatePicker;
const Option = Select.Option;
const TabPane = Tabs.TabPane;
let accountPaymentCompanies = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).accountPaymentCompanies : '';

@Form.create()
class VisitorConsultancy extends Component {
  state = {
    visible: true,
    registrationDesk: {},
    paymentDetails: [],
    loading: false,
    visaData: {},
    ext: null,
    linkUrl: null,
    agreement: []
  }


  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => {
      this.props.onClose();
    }, 50)
  }


  getDetails = async () => {
    let { recordId, form } = this.props;
    let { data } = await Request.getVisaEnquiryDetail({ _id: recordId });
    let dataToPrint = {}
    if (!data.registration) {
      let { doc } = await Request.getCountry(data.country);
      if (doc.visitorConsultancyType && doc.visitorConsultancyFee) {
        dataToPrint['total'] = parseFloat(doc.visitorConsultancyFee) *
          (doc.visitorConsultancyType === "Per Person" ? (data && data.applicants.length + 1) : 1);
        dataToPrint['paid'] = 0;
        dataToPrint['balance'] = dataToPrint.total;
      }

    } else {
      dataToPrint['total'] = data.registration.total;
      dataToPrint['paid'] = data.registration.paid;
      dataToPrint['balance'] = data.registration.balance;
    }
    this.setState({ registrationDesk: dataToPrint, paymentDetails: data.registrationPayments ? data.registrationPayments : [], visaData: data }, () => {
      form.setFieldsValue(dataToPrint);
    })

  }

  componentDidMount() {
    this.getDetails();
  }

  calculatePayment() {
    let balance = this.state.registrationDesk.balance
    let payment = this.props.form.getFieldValue('payment')
    let discount = this.props.form.getFieldValue('discount')
    let totalPaid = 0
    if (payment) {
      totalPaid = totalPaid + parseFloat(payment)
    }
    if (discount) {
      totalPaid = totalPaid + parseFloat(discount)
    }
    let currentBalance = parseFloat(balance) - parseFloat(totalPaid)
    this.setState({
      totalPayment: totalPaid
    })
    if (currentBalance < 0) {
      this.props.form.setFieldsValue({ 'currentBalance': balance })
    } else {
      this.props.form.setFieldsValue({ 'currentBalance': currentBalance })
    }

  }

  handleDiscountChange = (v) => {
    this.props.form.setFieldsValue({ discount: v });
    this.setState({ isDiscountApplied: v > 0 });

    setTimeout(() => {
      this.calculatePayment();
    }, 1000);
  };


  handleSubmit = (e) => {
    let { form, recordId } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData);
      values._id = recordId;
      this.setState({ loading: true });
      let response = await Request.addVisitorConsultancyCharges(values);
      this.setState({ loading: false });
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: response.message
        })
      }
      this.onClose();
    })
  }

  render() {
    let { visible, visaData } = this.state;
    let { form: { getFieldDecorator } } = this.props;
    let accountPaymentCompaniesArray = [];
    if (accountPaymentCompanies.indexOf(',')) {
      accountPaymentCompaniesArray = accountPaymentCompanies.split(',');
    }
    const inputFields = {
      fields: [
        {
          label: `Total Amount (${visaData.applicants && visaData.applicants.length ? visaData.applicants.length + 1 : 1} Applicants)`,
          key: 'total',
          type: 'number',
          disabled: true
        },

        {
          label: 'Previous Payment',
          key: 'paid',
          type: 'number',
          disabled: true
        },
        {
          label: 'Previous Balance',
          key: 'balance',
          type: 'number',
          disabled: true
        },
        {
          label: 'Current Payment',
          key: 'payment',
          required: true,
          type: 'number',
          onChange: (v) => {
            this.props.form.setFieldsValue({ 'payment': v })
            setTimeout(() => {
              this.calculatePayment()
            }, 1000)
          }
        },
        {
          label: 'Discount',
          key: 'discount',
          type: 'number',
          onChange: this.handleDiscountChange,
          // onChange: (v) => {
          //   this.props.form.setFieldsValue({ 'discount': v })
          //   setTimeout(() => {
          //     this.calculatePayment()
          //   }, 1000)
          // }
        },
        {
          label: 'Reason for Discount',
          key: 'discountReason',
          type: 'text',
          disabled: !this.state.isDiscountApplied, // Enable only if discount is applied
          required: this.state.isDiscountApplied
        },
        {
          label: 'Current Balance',
          key: 'currentBalance',
          type: 'number',
          disabled: true
        },
        {
          label: 'Company',
          key: 'paymentCompany',
          type: 'select',
          options: accountPaymentCompaniesArray,
          onChange: v => {
            this.props.form.setFieldsValue({ paymentCompany: v })
          }
        },
        {
          label: 'Generate Receipt',
          key: 'generateReceipt',
          type: 'select',
          options: ['Yes', 'No'],
          onChange: v => {
            this.props.form.setFieldsValue({ generateReceipt: v })
          }
        },
        {
          label: 'Apply GST',
          key: 'ApplyGST',
          required: true,
          type: 'select',
          options: [
            'Yes',
            'No'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({ ApplyGST: v })
          }
        },
        {
          label: 'Payment Type',
          key: 'paymentType',
          required: true,
          type: 'select',
          options: [
            'Cash',
            'Transfer'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({ paymentType: v })
          }
        },
        { label: 'Date of Receipt', key: 'dateOfReciept', required: true, type: 'date' }
      ]
    }

    const columns = [
      {
        title: 'Sr No.',
        key: 'serialNumber',
        render: (text, record, index) => (
          <div>{index + 1}</div>
        )
      },
      {
        title: 'Country Name',
        key: 'countryName'
      },
      {
        title: 'Payment Date',
        key: 'dateOfReceipt',
        render: (text, record) => (
          <div>{moment(record.dateOfReceipt).format(dateFormat)}</div>
        )
      },
      {
        title: 'Paid Amount',
        key: 'paid',
      },
      {
        title: 'Payment Method',
        key: 'paymentType',
      },
      {
        title: 'Discount',
        key: 'discount',
        render: (text, record) => (
          <div>{record.discount ? record.discount : "NA"}</div>
        )
      },
      {
        title: 'Discount Reason',
        key: 'discountReason',
        render: (text, record) => (
          <div>{record.discountReason ? record.discountReason : "NA"}</div>
        )
      }
    ]
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Visitor Consultancy Charges
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={800}
        visible={visible}>
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit} hideRequiredMark>
            <GetAllFormFields
              inputSchema={inputFields}
              apiurl={API_URL}
              getFieldDecorator={getFieldDecorator}
            />
            <Form.Item>
              <Row>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={this.state.loading}
                >
                  SAVE
                </Button>
              </Row>
            </Form.Item>
          </Form>
        </Card>
        <Card style={{ marginTop: 10 }} title={"Previous Payments"}>
          <TableComp dataSource={this.state.paymentDetails} columns={columns} />
        </Card>
      </Drawer>
    )
  }
}






class AllVisaEnquiry extends Component {
  deleteVisaEnquiry = async (record) => {
    this.setState({ load: true });
    let x = await Request.deleteVisaEnquiry({ _id: record._id });

    if (x && !x.error) {
      notification.success({
        message: x.message,
      });

      this.table.current.reload();
      this.setState({ load: false });
    } else {
      notification.error({ message: "Try again" });
    }
  };

  state = {
    count: 0,
    visaEnquiryfollowUpsDuesCount: 0,
    allBranches: [],
    showFollowUp: false,
    exportParams: {},
    activeTab: "0",
    showConsultancyDrawer: false,
    recordId: null,
    countryArr: [],
    isFollowUpOverdue: false,
    counsellorId: [],
    visitorVisaTypes: [],
    allUsers: [],
    showCallDrawer: false,
    recordForCall: {},
    enquiryStatus: ["Active", "Inactive", "Lead Closed", "Dead", "Parked"],
    ratingArr: [
      "Fit2Apply",
      "Potential",
      "Neutral",
      "Cold",
      "Dead",
      "Active",
      "Blank",
    ],
    time: {
      from: null,
      to: null,
    },
    filesStatusList: [
      { id: "1st Counselling Done", display: "1st Counselling Done" },
      { id: "Final Counselling Done", display: "Final Counselling Done" },
      { id: "Enrollment Done", display: "Enrollment Done" },
      {
        id: "Shared Documents Checklist",
        display: "Shared Documents Checklist",
      },
      { id: "Documents Pending", display: "Documents Pending" },
      { id: "Documents Received", display: "Documents Received" },
      { id: "File Preparation", display: "File Preparation" },
      {
        id: "Verification Done by Client",
        display: "Verification Done by Client",
      },
      { id: "Final Visa File Review", display: "Final Visa File Review" },
      { id: "Pending Fees Received", display: "Pending Fees Received" },
      { id: "Visa File Submission", display: "Visa File Submission" },
    ],
    visaStatusList: ["Visa Approved", "Visa Refused", "Visa Waiting"],
  };

  closeFollowUp = () => {
    this.setState(
      {
        showFollowUp: false,
      },
      () => {
        this.table.current.reload();
      }
    );
  };

  openFollowUps = (record) => {
    studentObj = {
      counsellorId: record.counsellorId._id,
      name: record.applicantName,
      _id: record._id,
    };
    this.setState({ showFollowUp: true });
  };

  restoreDeadVisaEnquiry = async (recordId) => {
    let response = await Request.recoverVisaEnquiry({ id: recordId });
    if (response.success) {
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
    this.table.current.reload();
  };

  moveToDeadEnquiry = async (recordId) => {
    let response = await Request.moveEnquiryToDead({ id: recordId });
    if (response.success) {
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
    this.table.current.reload();
  };


  moveToParkedEnquiry = async (recordId) => {
    let response = await Request.moveEnquiryToParked({ id: recordId });
    if (response.success) {
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
    this.table.current.reload();
  }

  apiRequest = (params, columns) => {
    return new Promise(async (resolve) => {
      // params.count = 200
      let { activeTab } = this.state;
      if (activeTab === "0") {
        // params.enquiryStatus = { $nin: ["Visa Approved", "VISA_APPROVED", "Visa Refused"] };
        // params.enquiryStatus = "Active";
      } else if (activeTab === "1") {
        params.visaStatus = { $nin: ["Visa Approved", "VISA_APPROVED", "Visa Refused"] };
        params.enquiryStatus = "Active";
      } else if (activeTab === "2") {
        // params.visaStatus = { $in: ["VISA_APPROVED", "Visa Approved", "Visa Refused"] };
        params.visaStatus = { $in: ["VISA_APPROVED", "Visa Approved"] };
        // params.enquiryStatus = "Active";
      } else if (activeTab === "3") {
        params.visaStatus = { $in: ["Visa Refused"] };
      } else if (activeTab === "4") {
        params.enquiryStatus = "Dead";
      } else if (activeTab === "5") {
        // params.enquiryStatus = { $nin: ["Visa Approved", "VISA_APPROVED", "Visa Refused"] };
        params.enquiryStatus = "Parked";
      } else if (activeTab === "6") {
        params.visaStatus = { $nin: ["Visa Approved", "VISA_APPROVED", "Visa Refused"] };
        params.enquiryStatus = "Leads";
      }
      // if(this.props.location.pathname == "/visaEnquiry/approved") {
      //     params.visaStatus = {$in:['VISA_APPROVED', 'Visa Approved']}
      //     params.enquiryStatus = "Active"
      // }else if (this.props.location.pathname == "/visaEnquiry/dead") {
      //     params.enquiryStatus = "Dead"
      // }else if(this.props.location.pathname == "/visaEnquiry/all") {
      //     params.visaStatus = {$ne:"Visa Approved"}
      //     params.enquiryStatus = "Active"
      // }

      if (!params.sortField) {
        params.sortField = "id";
        params.sortOrder = "descend";
      }
      if (this.state.time && this.state.time.from) {
        params.time = this.state.time;
      }
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId;
      }

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
        params.enquiryStatus = "Active";
      }

      this.setState({ exportParams: params });
      // if (params.dateOfBirth && params.dateOfBirth.length > 0) {
      //   var splitDate = params.dateOfBirth[0].split("-");
      //   const monthNames = [
      //     "January",
      //     "February",
      //     "March",
      //     "April",
      //     "May",
      //     "June",
      //     "July",
      //     "August",
      //     "September",
      //     "October",
      //     "November",
      //     "December",
      //   ];
      //   var monthName = monthNames[splitDate[1] - 1];

      //   params.dateOfBirth =
      //     splitDate[0] + "-" + monthName + "-" + splitDate[2];

      //   const stringToDate = new Date(params.dateOfBirth);
      //   params.dateOfBirth = {
      //     $gte: stringToDate.setHours(0, 0, 0),
      //     $lt: stringToDate.setHours(23, 59, 59),
      //   };
      // } else {
      //   delete params.dateOfBirth;
      // }
      let data = await Request.getAllVisaEnquiryList({
        ...params,
        regExFilters: ["applicantName"],
      });
      delete data.error;
      delete data.type;

      this.setState({
        count: data.total,
        allBranches: data.allBranches,
        visaEnquiryfollowUpsDuesCount: data.visaEnquiryfollowUpsDuesCount,
      });

      resolve(data);
    });
  };

  loadCountry() {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth(params)
      .then((resp) => {
        if (resp) {
          let temp = [];
          _.each(resp.data, (vv) => {
            temp.push({
              text: vv.countryName,
              value: vv.countryName,
            });
          });
          this.setState({ countryArr: temp });
        }
      })
      .catch((err) => { });
  }

  reload = () => {
    this.table.current.reload();
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
  }

  followUpsCallback(isFollowUpOverdue) {
    this.setState(
      {
        isFollowUpOverdue: isFollowUpOverdue,
      },
      () => {
        this.table.current.reload();
      }
    );
  }
  getVisitorVisaTypes = async () => {
    let params = {
      results: 100,
      count: 100,
    };
    let response = await Request.getAllVisitorVisaType(params);
    let visitorVisaTypes = [];
    _.each(response.data, (item) => {
      visitorVisaTypes.push({ value: item._id, text: item.visitorVisaType });
    });
    this.setState({ visitorVisaTypes });
  };

  callback = (value) => {
    if (value) {
      this.chooseTab(value);
    }
  };

  chooseTab(value) {
    this.setState(
      {
        activeTab: value,
      },
      () => {
        this.table.current.reload();
      }
    );
  }

  closeCallDrawer = () => {
    this.setState({ showCallDrawer: false, recordForCall: {} }, () => {
      this.reload()
    })
  }


  closeConsultancyDrawer = () => {
    this.setState({ showConsultancyDrawer: false, recordId: null }, () => {
      this.table.current.reload();
    })
  }

  getVisitorVisaCounsellors = async () => {
    let params = {
      sortField: "_id",
      sortOrder: "ascend",
      results: 200,
      active: true,
      userType: { $ne: "Student" },
      userBranch: localUser.userBranch,
      isVisitorVisaCounsellor: true,
    };
    let response = await Request.loadUser({
      ...params,
      regExFilters: ["name"],
    });
    let userArray = [];
    response.data.map((user, index) => {
      userArray.push({
        id: user._id,
        display: user.name,
      });
    });
    this.setState({ allUsers: userArray });
  };

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1],
        },
      },
      () => {
        this.reload();
      }
    );
    if (date[0] === undefined) {
      setTimeout(() => {
        this.reload();
      }, 500);
    }
  };

  componentDidMount = () => {
    this.loadCountry();
    this.getVisitorVisaTypes();
    this.getVisitorVisaCounsellors();
  };
  checkUrlExt = (url) => {
    return url.split(/[#?]/)[0].split('.').pop().trim();
  }
  viewPDF = (record) => {
    const { agreement } = record;
    if (agreement.length > 0) {
      let linkUrl = LAPI_URL + "/" + agreement[0].url;
      let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
      if (this.checkUrlExt(linkUrl)) {
        this.setState({ ext: ext, linkUrl: linkUrl, agreement: agreement })
      } else {
        notification.warning({
          message: 'Agreement not exists!!!.'
        })
      }
    }
  }

  closeDocument = () => {
    this.setState({ ext: null, linkUrl: null, agreement: [] });
  }

  exportExcel = async () => {
    let { exportParams } = this.state;
    let x = await Request.exportVisaEnquiryToExcel(exportParams);
    // let x = await Request.exportVisaEnquiryToExcel({
    //   regExFilters: ["name"],
    // });
    if (!x.error) {
      window.open(x.url);
    }
  };

  renderStatus = (val) => {
    if (val === "Super Hot") {
      return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
    }
    if (val === "Fit2Apply") {
      return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
    }

    if (val === "Neutral") {
      return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
    }

    if (val === "Potential") {
      return <div className={styles.Potential}>{val.toUpperCase()}</div>;
    }

    if (val === "Dead") {
      return <div className={styles.dead}>{val.toUpperCase()}</div>;
    }

    if (val === "Cold") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
    if (val === "Active") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
  };

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      const followupDate = moment(followUp.followUpDate).format("YYYYMMDD");
      return todayDate >= followupDate ? true : false;
    }
  };

  render() {
    const { dispatch } = this.props;
    const {
      allBranches,
      ratingArr,
      filesStatusList,
      allUsers,
      visaStatusList,
      countryArr,
      enquiryStatus,
      visitorVisaTypes,
      ext,
      linkUrl,
      agreement
    } = this.state;

    const columns = [
      {
        title: "Action",
        key: "operation",
        dataindex: "operation",
        fixed: true,
        width: 160,
        render: (text, record) => (
          <div>
            <RightsWrapper myRight={"VisaEnquiry.edit"}>
              <Tooltip title="Edit Visa Enquiry">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  href={`/visaEnquiry/edit-visaEnquiry?id=${record._id}`}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={"VisaEnquiry.edit"}>
              <Tooltip title="Notes">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  onClick={() => this.openFollowUps(record)}
                  icon="calendar"
                />
              </Tooltip>
            </RightsWrapper>
            {record.enquiryStatus === "Active" || record.enquiryStatus === "Leads" ? (
              <>
                <Tooltip title="Move To Dead Enquiry">
                  <Popconfirm
                    title="Are you sure?"
                    onConfirm={() => this.moveToDeadEnquiry(record._id)}
                  >
                    <Button
                      className={styles.btn}
                      size={"small"}
                      shape="circle"
                      icon="forward"
                    />
                  </Popconfirm>
                </Tooltip>
              </>
            ) : (
              <Tooltip title="Restore Enquiry">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  onClick={() => {
                    this.restoreDeadVisaEnquiry(record._id);
                  }}
                  icon="backward"
                />
              </Tooltip>
            )}
            {record.enquiryStatus === "Dead" || record.enquiryStatus === "Active" || record.enquiryStatus === "Leads" ?
              <Tooltip title="Move To Parked Enquiry">
                <Popconfirm
                  title="Are you sure?"
                  onConfirm={() => this.moveToParkedEnquiry(record._id)}
                >
                  <Button
                    className={styles.btn}
                    size={"small"}
                    shape="circle"
                    icon="car"
                  />
                </Popconfirm>
              </Tooltip>

              : null}

            {record.enquiryStatus === "Parked" || record.enquiryStatus === "Leads" ?
              <Tooltip title="Move to Active">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  onClick={() => {
                    this.restoreDeadVisaEnquiry(record._id);
                  }}
                  icon="backward"
                />
              </Tooltip>
              : null
            }
            <RightsWrapper myRight={"VisaEnquiry.delete"}>
              <Tooltip title="Delete Visa Enquiry">
                <Popconfirm
                  title="Are you sure to delete this Visa Enquiry?"
                  onConfirm={() => {
                    this.deleteVisaEnquiry({ _id: record._id });
                  }}
                  onCancel={() => {
                    console.log();
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    className={styles.btn}
                    size={"small"}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
            <Tooltip title="Consultancy" >
              <Button icon="pay-circle" shape="circle" size="small" onClick={() => this.setState({ showConsultancyDrawer: true, recordId: record._id })}></Button>
            </Tooltip>
            {record.agreement && record.agreement.length > 0 ?
              <Tooltip title="View Agreement" >
                <Button
                  shape="circle"
                  size="small"
                  style={{ marginLeft: '5px' }}
                  onClick={() => this.viewPDF(record)}
                  icon="file"
                />
              </Tooltip> : null}
          </div>
        ),
      },

      {
        title: "ID",
        key: "id",
        dataIndex: "id",
        sorter: true,
        searchTextName: "id",
        filterRegex: true,
        width: 90,
      },
      {
        title: "Applicant Name",
        key: "applicantName",
        dataIndex: "applicantName",
        searchTextName: "applicantName",
        filterRegex: true,
        width: 120,
        render: (text, record) => (
          <React.Fragment>
            <div
              className={
                this.followUpExtendedDate(
                  record.followUp ? record.followUp : ""
                )
                  ? "antd-pro-containers-student-inquiry-all-styles-followUpExtendedDate"
                  : ""
              }
            >
              <Tooltip>
                <p>{text}</p>
              </Tooltip>
            </div>
          </React.Fragment>
        ),
      },
      {
        title: "DOB",
        key: "dateOfBirth",
        dataIndex: "dateOfBirth",
        searchTextName: `${dateFormat}`,
        sorter: true,
        width: 120,
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format(dateFormat)
                : ""}
            </div>
          );
        },
      },
      {
        title: "Mobile Number",
        key: "mobileNumber",
        dataIndex: "mobileNumber",
        searchTextName: "mobile",
        filterRegex: true,
        width: 130,
        render: (val, record) => {
          return (
            <div>
              {" "}
              {val &&
                val.length >= 10 &&
                rightAuth.checkRights("ShowClickToCall.view") ? (
                <Tooltip title="Start Call">

                  <Button
                    className="ant-btn ant-btn-primary"
                    onClick={() => {
                      this.setState({ showCallDrawer: true, recordForCall: record })
                    }}
                  // onClick={(e) => {
                  //   dispatch(showLoader());
                  //   Request.callInitiate({
                  //     mobile: val,
                  //   }).then(({ data, error, message }) => {
                  //     dispatch(hideLoader());
                  //     if (!error) {
                  //       notification.success({
                  //         message: message,
                  //       });
                  //     } else {
                  //       notification.error({
                  //         message: message,
                  //       });
                  //     }
                  //   });
                  // }}
                  >
                    Click To Call
                  </Button>
                </Tooltip>
              ) : (
                val
              )}
            </div>
          );
        },
      },
      {
        title: 'Enquiry Date',
        key: 'lastFollowUpDate',
        width: 120,
        searchTextName: `lastFollowUpDate ${dateFormat}`,
        render: (text, record) => (
          <div>{record && record.followUp && record.followUp.createdByUser && record.followUp.createdByUser.time ? moment(record.followUp.createdByUser.time).format(dateFormat) : ""}</div>
        )
      },
      {
        title: "Enquiry Status",
        key: "enquiryStatus",
        width: 180,
        filters:
          enquiryStatus && enquiryStatus.map((x) => ({ value: x, text: x })),
      },
      {
        title: "Follow Up",
        key: "followUp",
        width: 200,
        dataIndex: "followUp",
        render: (text, record) => {
          return <LatestVisaFollowUp info={text} />;
        },
      },
      {
        title: "Type",
        key: "type",
        width: 180,
        filters:
          visitorVisaTypes,
        render: (text, record) => {
          return <div>{record.visitorVisaType}</div>;
        },
      },
      {
        title: "Visa Status",
        key: "visaStatus",
        width: 180,
        filters:
          visaStatusList && visaStatusList.map((x) => ({ value: x, text: x })),
      },
      {
        title: "Rating",
        key: "rating",
        dataIndex: "rating",
        filters: ratingArr && ratingArr.map((x) => ({ value: x, text: x })),
        width: 120,
        render: (val, record) => {
          return this.renderStatus(val);
        },
      },

      {
        title: "Branch",
        key: "branchId",
        filters: allBranches,
        dataIndex: "branchId",
        width: 120,
        render: (val, record) => {
          return <div>{val._id ? val.branchName : ""}</div>;
        },
      },

      {
        title: "Parent's Mobile No",
        key: "landlineNumber",
        dataIndex: "landlineNumber",
        searchTextName: "landlineNumber",
        filterRegex: true,
        width: 130,
      },
      {
        title: "Address",
        key: "address",
        width: 130,
      },
      {
        title: "No Of people Applying",
        key: "noOfPeopleApplying",
        dataIndex: "noOfPeopleApplying",
        width: 130,
      },
      {
        title: "Country Name",
        key: "country",
        dataIndex: "country",
        filters: countryArr,
        width: 120,
        render: (text, record) => {
          return <div>{record.countryName}</div>;
        },
      },
      {
        title: "No of Years",
        key: "longYears",
        dataIndex: "longYears",
        width: 110,
      },
      {
        title: "Immigration Status",
        key: "immigrationStatus",
        dataIndex: "immigrationStatus",
        width: 120,
      },

      {
        title: "Occupation",
        key: "occupation",
        dataIndex: "occupation",
        width: 110,
      },
      {
        title: "Counsellor",
        key: "counsellorId",
        dataIndex: "counsellorId.name",
        width: 110,
        filters:
          allUsers && allUsers.map((x) => ({ value: x.id, text: x.display })),
      },
      {
        title: "Annual Income",
        key: "annualIncome",
        dataIndex: "annualIncome",
        width: 110,
      },
      {
        title: "Financial worth",
        key: "financialWorth",
        dataIndex: "financialWorth",
        width: 110,
      },
      {
        title: "File Status",
        key: "fileStatus",
        width: 180,
        filters:
          filesStatusList &&
          filesStatusList.map((x) => ({ value: x.id, text: x.display })),
        render: (text, record) => {
          if (record) {
            const visaDesk = record;
            if (visaDesk && visaDesk.fileStatus === "Visa File Dispatched") {
              return (
                <div>
                  <div>
                    {visaDesk && visaDesk.fileStatus === "Visa File Dispatched"
                      ? "Visa File Submission"
                      : visaDesk.fileStatus}
                  </div>
                  <small>
                    {visaDesk && visaDesk.visaDate
                      ? moment(visaDesk.visaDate).format("lll")
                      : ""}
                  </small>
                </div>
              );
            } else {
              return <div>{visaDesk && visaDesk.fileStatus}</div>;
            }
          } else {
            return null;
          }
        },
      },

      {
        title: "Created By",
        key: "createdByUser",
        dataIndex: "createdByUser",
        width: 110,
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },
      {
        title: "Updated By",
        key: "updatedByUser",
        dataIndex: "updatedByUser",
        width: 110,
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },
    ];
    return (
      <PageHeaderWrapper
        title={` Visa Enquiry List : ${this.state.count} `}
        subTitle={`Follow Up Overdue : ${this.state.visaEnquiryfollowUpsDuesCount
          }`}
        followUpsCallback={this.followUpsCallback}
      >
        {
          ext != null && agreement.length > 0 ?
            <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
            : null
        }
        {
          this.state.showCallDrawer ?
            <ClickToCallDrawer record={this.state.recordForCall} type="inquiry" onClose={this.closeCallDrawer} />
            : null
        }
        {
          this.state.showConsultancyDrawer ?
            <VisitorConsultancy recordId={this.state.recordId} onClose={this.closeConsultancyDrawer} /> : null
        }
        {this.state.showFollowUp ? (
          <VisaListFollowUps
            studentObj={studentObj}
            onClose={this.closeFollowUp}
          />
        ) : null}
        <Card>
          <Row>
            <Col span={6}>
              <h4>Filter By Date</h4>
              <RangePicker
                format="YYYY-MM-DD"
                placeholder={["Start Date", "End Date"]}
                onOk={() => this.table.current.reload()}
                onChange={this.chooseRangerPicker}
              />
            </Col>
            <Col span={6} style={{ marginLeft: 10 }}>
              <h4>Filter By Counsellor</h4>
              <Select
                allowClear
                style={{
                  marginRight: 16,
                }}
                mode="tags"
                showSearch={true}
                className={common.width100Pr}
                value={this.state.counsellorId}
                placeholder="Select Option"
                optionFilterProp="display"
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={(counsellorId) => {
                  this.setState(
                    {
                      counsellorId: counsellorId,
                    },
                    () => {
                      setTimeout(() => {
                        this.table.current.reload();
                      }, 500);
                    }
                  );
                }}
              >
                {allUsers.map((val, idn) => {
                  return (
                    <Option key={idn} value={val.id}>
                      {val.display}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col span={3}>
              <div style={{ textAlign: "right", marginTop: "20px" }}>
                {rightAuth.checkRights("VisaInquiryExcelExport.view") ? (
                  <Button
                    type={"default"}
                    loading={this.state.exportLoading}
                    onClick={() => {
                      this.exportExcel();
                    }}
                  >
                    Export Excel
                  </Button>
                ) : null}
              </div>
            </Col>
            <Col span={2}>
              <RightsWrapper myRight={"VisaEnquiry.add"}>
                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <Button type="primary" onClick={() => window.open("/visaEnquiry/add", "_blank")}>Add</Button>
                </div>
              </RightsWrapper>
            </Col>
          </Row>
        </Card>
        <Card bordered={true}>
          <Tabs
            type="card"
            onChange={this.callback}
            activeKey={this.state.activeTab}
          >
            <TabPane tab={"All"} key={0}>
              <TableComp
                showSelector={true}
                columns={columns}
                ref={this.table}
                apiRequest={(params) => this.apiRequest(params, columns)}
                extraProps={{ scroll: { x: 1500 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={"Active"} key={1}>
              {/* <Row gutter={16}>
                <Col span={4}><Button /></Col>
              </Row> */}
              <TableComp
                showSelector={true}
                columns={columns}
                ref={this.table}
                apiRequest={(params) => this.apiRequest(params, columns)}
                extraProps={{ scroll: { x: 1500 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={"Approved"} key={2}>
              <TableComp
                showSelector={true}
                columns={columns}
                ref={this.table}
                apiRequest={(params) => this.apiRequest(params, columns)}
                extraProps={{ scroll: { x: 1500 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={"Refused"} key={3}>
              <TableComp
                showSelector={true}
                columns={columns}
                ref={this.table}
                apiRequest={(params) => this.apiRequest(params, columns)}
                extraProps={{ scroll: { x: 1500 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={"Dead"} key={4}>
              <TableComp
                showSelector={true}
                columns={columns}
                ref={this.table}
                apiRequest={(params) => this.apiRequest(params, columns)}
                extraProps={{ scroll: { x: 1500 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={"Parked"} key={5}>
              <TableComp
                showSelector={true}
                columns={columns}
                ref={this.table}
                apiRequest={(params) => this.apiRequest(params, columns)}
                extraProps={{ scroll: { x: 1500 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={"Leads"} key={6}>
              <TableComp
                showSelector={true}
                columns={columns}
                ref={this.table}
                apiRequest={(params) => this.apiRequest(params, columns)}
                extraProps={{ scroll: { x: 1500 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
  location: router.location,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllVisaEnquiry);
